// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.remark{\n  color: red;\n  margin-bottom: 3px;\n  font-size: 13px;\n  text-align: center;\n  line-height: 16px;\n}\n.notice{\n  color: red;\n  text-align: start;\n}\n.upload-file-check-box{\n  left: -30px\n}\n.font-size-cus {\n  font-size: 18px;\n  font-weight: Bold;\n}\n.modal-label {\n  font-size: 18px;\n  font-weight: Bold;\n}\n", ""]);
// Exports
module.exports = exports;
